/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import Icon from '../../../../elements/Icon/Icon'
import IcClose from 'app/elements/Icon/ic-close'
import IcCheck from 'app/elements/Icon/ic-check'
import DropdownList from 'app/modules/IdentifiersList/DropdownList'
import { darkBlue } from 'styles/settings/colors'
import { Wrapper, Select, dropdownArrow, ItemWrapper, Text, Delete } from './styles'

class SelectPlateFilterSelection extends React.Component {
  state = {
    showDropdown: false
  }

  toggleDropdown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown
    })
  }

  showCurrentOption = () => {
    const {
      currentOption,
      editingSelection,
      showEditSelectionBlock,
      editingNewSelectionLength
    } = this.props
    if (currentOption) {
      if (currentOption.id === 'TODAS' && !editingNewSelectionLength) {
        return currentOption.descricaoFiltro
      }
      if (showEditSelectionBlock) {
        return `${currentOption.descricaoFiltro} (${currentOption.info.length})`
      }
      if (editingSelection && editingNewSelectionLength) {
        return `${currentOption.descricaoFiltro} (${editingNewSelectionLength})`
      }
      if (editingNewSelectionLength) {
        return `Nova seleção (${editingNewSelectionLength})`
      } else {
        return `${currentOption.descricaoFiltro} (${currentOption.info.length})`
      }
    }
    if (editingNewSelectionLength) {
      return `Nova seleção (${editingNewSelectionLength})`
    }

    return 'Minhas seleções'
  }
  render() {
    const { showDropdown } = this.state
    const { options, setOption, currentOption, onDelete } = this.props
    return (
      <Wrapper>
        <Select type="button" onClick={() => this.toggleDropdown()}>
          {this.showCurrentOption()}
          <Icon
            icon="dropdown-arrow"
            svgStyle={dropdownArrow}
            width="12"
            height="7"
            viewBox="0 0 12 7"
          />
        </Select>
        <DropdownList withIcon isOpen={showDropdown} onClose={() => this.toggleDropdown()}>
          <ItemWrapper>
            <Text
              onClick={() =>
                setOption({
                  id: 'TODAS',
                  descricaoFiltro: 'Todas as placas',
                  info: []
                })
              }
            >
              Todas as placas
            </Text>
          </ItemWrapper>
          {options.map(option => (
            <ItemWrapper key={option.id}>
              <Text onClick={() => setOption(option)}>
                {option.descricaoFiltro} ({option.info.length})
              </Text>

              {currentOption && currentOption.descricaoFiltro === option.descricaoFiltro ? (
                <span>
                  <IcCheck />
                </span>
              ) : (
                <Delete onClick={() => onDelete(option)}>
                  <IcClose width={16} height={16} fill={darkBlue} />
                </Delete>
              )}
            </ItemWrapper>
          ))}
        </DropdownList>
      </Wrapper>
    )
  }
}

export default SelectPlateFilterSelection



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/SelectPlateFilterSelection/index.js